module.exports = "<button type=\"button\" class=\"btn btn-outline-secondary\" ng-click=\"$ctrl.ask()\">\r\n    Zadaj pytanie\r\n</button>"